import { useEffect, useState } from "react";

export default function ReadProgress() {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      const doc = document.documentElement;
      const scrollTop = doc.scrollTop || document.body.scrollTop;
      const height = doc.scrollHeight - doc.clientHeight;
      const pct = height > 0 ? scrollTop / height : 0;
      setProgress(Math.min(1, Math.max(0, pct)));
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="read-progress-shell" data-testid="read-progress">
      <div className="read-progress-bar" style={{ transform: `scaleX(${progress})` }} />
    </div>
  );
}
